export var screenSizes = {
    screen: {
        small: { min: 541, max: 540 },
        medium: { min: 810, max: 809 },
        large: { min: 990, max: 989 },
        ipad: { min: 835, max: 834 },
    },
};
//# sourceMappingURL=props.js.map